var _defs, _path, _g, _g2, _circle, _polygon, _path2, _polygon2, _circle2, _circle3, _path3, _circle4, _path4, _circle5, _path5, _path6, _path7, _polygon3, _circle6, _circle7, _polygon4, _circle8, _path8, _circle9, _path9, _polygon5, _polyline, _circle10, _polygon6, _polyline2, _circle11, _path10, _circle12, _polygon7, _circle13, _polygon8, _circle14, _polygon9, _circle15, _polygon10, _line, _circle16, _circle17, _path11, _path12, _circle18, _polygon11, _polyline3, _polyline4, _path13, _circle19, _path14, _path15, _path16, _path17, _path18, _path19, _circle20, _path20, _line2, _path21, _circle21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle22, _path29, _line3, _path30, _circle23, _path31, _circle24, _path32, _path33, _circle25, _path34, _g3, _circle26, _path35, _polygon12, _path36, _ellipse, _polygon13, _ellipse2, _path37, _circle27, _polygon14, _circle28, _path38, _circle29, _path39, _circle30, _path40, _polygon15, _circle31, _circle32, _polygon16, _circle33, _path41, _circle34, _polygon17, _circle35, _polygon18, _circle36, _path42, _circle37, _polygon19, _circle38, _polygon20, _circle39, _polygon21, _circle40, _polygon22, _circle41, _polygon23, _path43, _polygon24, _circle42, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{clip-path:url(#clippath-1);}.cls-5,.cls-6{fill:#020202;}.cls-7,.cls-8{fill:#958df8;}.cls-9{fill:#7167e1;}.cls-10,.cls-11{fill:#e0d0fd;}.cls-10,.cls-11,.cls-8,.cls-12,.cls-6,.cls-3{stroke-width:2.00px;}.cls-10,.cls-11,.cls-12{stroke:#e0d0fd;}.cls-10,.cls-8,.cls-12,.cls-6,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-11{stroke-miterlimit:10;}.cls-8,.cls-3{stroke:#020202;}.cls-12{fill:#fff;}.cls-6{stroke:#7167e1;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1247.49,1085.53c10.24,2.61,21.58,5.57,33.38,8.73,82.76,22.14,187.47,54.49,86.51,52.84-54.89-.89-132.18-11.53-207.42-20.39-87.45-10.32-172.16-18.26-215.74-5.76h0c-23.35,6.69-34.89,19.24-28.75,40.43,27.5,94.79-424.08-3.08-568.16,0-106.85,2.28-90-29.93-9.77-49.23,27.96-6.73,63.62-11.88,104.41-13.46,157.87-6.12-610.54-85.83-238.73-101.61h1259.2s.75,47.68-180.91,69.9c-10.34,1.26-21.27,2.45-32.83,3.54-8.52.8-9.46,12.88-1.17,15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 192.36,
    y: 586.92,
    width: 1307.23,
    height: 410.18
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1247.49,1085.53c10.24,2.61,21.58,5.57,33.38,8.73,82.76,22.14,187.47,54.49,86.51,52.84-54.89-.89-132.18-11.53-207.42-20.39-87.45-10.32-172.16-18.26-215.74-5.76h0c-23.35,6.69-34.89,19.24-28.75,40.43,27.5,94.79-424.08-3.08-568.16,0-106.85,2.28-90-29.93-9.77-49.23,27.96-6.73,63.62-11.88,104.41-13.46,157.87-6.12-610.54-85.83-238.73-101.61h1259.2s.75,47.68-180.91,69.9c-10.34,1.26-21.27,2.45-32.83,3.54-8.52.8-9.46,12.88-1.17,15Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1426.75,1082.11c-122.49-2.3-236.98-10.2-337.22-27.43-39.3-6.75-71.46-15.46-105.45-23.61-37.39-8.97-79.62-16.02-131.02-19.78-29.34-2.14-59.77-2.04-89.71-1.55-41.72.68-83.36,1.83-123.28,5.15-45.85,3.8-86.7,9.53-120.95,17.63-47.66,11.28-92.96,23.13-142.16,34.01-59.18,13.09-120.5,25.73-196.44,33.47-27.71,2.82-55.86,5.41-86.9,5.3-.07-4.68-.14-9.37-.22-14.05,21.53-.96,40.66-3.41,60.25-5.52,73.28-7.89,146.69-15.79,210.88-27.49,14.78-2.69,29.53-5.69,37.1-10.02,9.34-5.34-.06-8.8-24.46-8.93-31.18-.17-60.61,1.94-90.46,3.66-35.94,2.06-70.55,5.47-109.14,4.86-28-.44-55.93-1.77-84.22-1.01.02-3.75.05-7.49.08-11.24,105.61.94,204.88-5.24,301.71-14.53,63.79-6.12,128.57-11.72,195.69-15.48,34.24-1.92,69.46-2.68,104.64-3.57,50.11-1.26,99.73-.31,149.17.45,86.38,1.32,172.61,2.9,259.27,2.57,63.16-.25,124.63-3.41,186.61-5.75,45.19-1.7,90.32-3.64,136.36-3.6.08,2.2.16,4.4.25,6.6-17.28-.45-33.86.66-50.54,1.36-80.43,3.39-160.42,7.38-242.93,7.11-25.28-.08-50.91.83-75.91,1.89-38.63,1.64-52.18,9.02-32.77,17.01,3.9,1.6,7.57,3.26,12.27,4.73,43.65,13.64,103.62,22.04,169.42,28.24,70.6,6.64,145.41,7.3,220.32,7.32-.07,4.07-.15,8.13-.22,12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1426.86,1124.78c-33.51,1.33-66.94,2.8-100.56,3.95-53.66,1.84-106.91,4.26-161.58,4.48-47.11.18-93.71.01-140.46-1.72-48.59-1.8-91.24-6.76-132.37-12.53-63.04-8.84-123.93-18.48-194.6-24-64.83-5.07-130.19-8.89-198.28-5.36-51.05,2.65-93.69,9.6-132.15,17.67-69.25,14.54-145.66,26.16-234.23,33.04-12.97,1.01-24.12,3.31-38.85,3.07-.13-4.38-.26-8.76-.39-13.14,49.16-2.29,92.62-7.92,134.51-13.86,59.98-8.51,116.89-18.2,176.06-27.04,59.31-8.86,120.8-16.7,190.29-20.5,65.02-3.56,129.79-3.12,194.68-.13,83.68,3.86,158.69,12.64,230.98,22.84,57.6,8.12,119.77,13.07,185.75,15.56,74.67,2.83,148.47,1.79,221.42-2.84-.08,6.84-.15,13.68-.23,20.52Zm-368.82-1.74c10.47-.15,21.18-.01,31.34-.5,21.51-1.04,25.76-3.54,14.3-7.92-3.05-1.17-7.26-2.18-11.21-3.2-20.91-5.41-45.75-9.67-72.31-13.4-82.29-11.55-164.49-23.32-263.48-24.94-25.25-.41-48.7,1.67-43.72,7.85,3.2,3.97,16.97,6.24,30.78,7.9,66.62,8.03,126.11,18.94,194.29,26.32,38.23,4.14,76.39,8.22,119.99,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m887.68,1197.86c35.72.72,69.9-1.79,104.75-2.83,54.28-1.62,108.5-3.53,162.35-5.67,56.66-2.25,113.18-2.78,169.93-2.29,33.97.29,67.9.79,101.92.66.29,6.02.16,12.05,1.05,18.07.41,2.74-4.5,3.6-15.16,3.34-3.25-.08-6.57-.01-9.86-.01-428.22,0-856.45,0-1284.67,0-25.08,0-25.14,0-25.08-6.04.05-5.1.27-10.2.41-15.3,65.14-.37,129.14,1.6,193.16,4.37,64.22,2.78,129.21,4.51,194.32,5.99,63.94,1.45,127.88,2.31,192.08,2.88,61.69.54,122.85-.67,184.24-1.18,6.77-.06,12.92-.5,17.62-1.73,4.31-.08,8.63-.16,12.94-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m93.39,938.13c59.48.98,118.87,2.07,178.65,2.03,67.98-.05,134.08-2.82,200.04-6.15,76.72-3.87,152.38-9.06,230.35-11.35,71.1-2.09,142.56-1.99,213.52.98,85.58,3.58,171,7.39,256.84,10.57,24.28.9,49.33,1.38,74.42,1.28,59.82-.25,119.67-.13,179.51-.17.08,2.83.17,5.66.25,8.49-32.85-.05-65.93.46-98.52-.25-65-1.42-129.59-3.97-194.63-5.21-84.18-1.6-166.89-5.37-250.28-8.11-28.54-.94-58.93-2-86.97,1.36-19.82,2.38-22.67,6.26-7.96,10.06,9.84,2.54,21.44,4.5,34.02,6.22,52.62,7.17,110.29,11.38,167.43,15.91,52.32,4.15,105.89,7.36,161,7.65,91.95.49,183.99.12,275.99.12-.07,3.13-.13,6.26-.2,9.39-70.94-.77-141.69,1.36-212.59.8-70.69-.56-141.29-1.57-209.47-6.49-57.21-4.12-111.32-10.07-165.16-16.15-61.51-6.94-122.93-13.91-189.82-17.69-49.14-2.78-98.53-2.55-148.17-1.08-59.63,1.77-119.34,3.4-178.87,5.33-43.38,1.41-86.66,2.87-130.36,3.69-34.06.64-66.12-1.76-99.08-2.78.02-2.82.04-5.63.06-8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1426.74,1174.91c-68.32-.16-135.29-3.06-202.72-5.21-81.25-2.6-162.52-3.37-244.55-.02-79.44,3.24-156.46,8.82-235.92,11.98-83.84,3.34-164.06,1.25-243.27-5.75-52.78-4.67-102.31-11.27-157.52-14.46-42.14-2.43-84.65-1.96-127.03-.7-41.69,1.24-82.23,3.81-122.37,6.69-.02-2.19-.05-4.37-.07-6.56,25.15.44,44.87-3.11,66.5-5.14,23.73-2.23,46.46-5.04,69.69-7.56,58.9-6.4,119.65-6.62,182.36-3.67,73.69,3.47,145.01,9.43,219.46,11.89,62.06,2.05,124.33,3.25,187.67,2.02,59.95-1.16,119.75-2.66,179.48-4.18,56.05-1.42,111.91-3.04,168.33-2.55,66.65.58,133.17,1.67,199.47,3.49,20.11.55,40.42.69,60.63,1.02.08,1.27.16,2.54.25,3.82-42.95-.89-85.86-1.65-128.19-3.92-21.18-1.14-43.18-2.67-65.63-.89-8.04.64-15.52,1.71-16.99,3.49-1.7,2.07,7.1,3.13,13.77,4.04,23,3.15,48.24,4.76,74.43,5.57,40.76,1.26,81.57,2.44,122.36,3.66-.04.98-.08,1.96-.12,2.94Zm-773.27,2.72c5.48,0,14.03.05,22.56,0,34.83-.25,69.07-1.19,101.08-4.78,9.09-1.02,15.32-2.49,14.22-4.99-.99-2.25-7.45-3.42-16.32-4.13-14.36-1.14-28.61-2.16-44.11-1.92-57.31.9-113.35-1.51-169.65-3.49-21.9-.77-43.29-2.56-65.97-2.12-9.07.18-16.72.69-21.04,2.77-4.41,2.12-1.22,3.99,4.34,5.58,7.07,2.01,14.89,3.84,24.79,5.21,45.53,6.31,95.18,8.21,150.12,7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m93.43,978.96c40.78,1.65,82.09,2.88,123.08,1.66,35.87-1.07,71.54-1.63,107.58-1.68,14.23-.02,27.38.77,40,2.04,10.37,1.05,19.85,2.67,20.76,5.63.89,2.88-6.11,4.81-16.02,6.43-27.26,4.45-57.8,7.14-89,9.54-60.63,4.66-122.95,7.12-186.47,8.05.02-10.55.05-21.11.07-31.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1285.18,
    cy: 1028.23,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1254.58,
    cy: 1040.47,
    r: 4.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 645.36,
    cy: 1040.83,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 286.11,
    cy: 1016.56,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 612.42,
    cy: 1041.87,
    r: 4.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 679.68,
    cy: 1050.71,
    r: 4.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 318.61,
    cy: 1010.5,
    r: 4.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m565.07,965.71l45.39,8.49-11.99,64.09-45.39-8.49-16.21,86.65-79.5-14.87,16.21-86.65-164.23-30.72,5.79-50.73,216.33-232.57,80.32,15.03-46.73,249.78Zm-168.08-31.44l88.58,16.57,26.45-141.39-6.92,8.1-108.1,116.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m549.64,962.82l45.39,8.49-11.99,64.09-45.39-8.49-16.21,86.65-79.5-14.87,16.21-86.65-164.23-30.72,5.79-50.73,216.33-232.57,80.32,15.03-46.73,249.78Zm-168.08-31.44l88.58,16.57,26.45-141.39-6.92,8.1-108.1,116.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m942.95,1139.2c-21.43,52.11-48.6,87.54-81.52,106.28-32.92,18.74-70.18,19.56-111.76,2.46-41.07-16.89-66.9-43.34-77.51-79.37-10.6-36.03-5.77-79.43,14.5-130.2l28.52-69.37c21.64-52.63,48.97-88.09,82.02-106.38,33.04-18.29,70.09-18.99,111.16-2.1,41.07,16.88,66.92,43.3,77.56,79.24,10.64,35.95,5.82,79.3-14.45,130.07l-28.52,69.37Zm-43.44-107.02c12.85-31.26,17.94-55.77,15.26-73.54-2.68-17.76-13.08-30.37-31.2-37.82-17.6-7.24-33.38-5.79-47.32,4.32-13.95,10.12-27.1,29.49-39.48,58.12l-37.71,91.72c-12.64,30.74-17.85,55.31-15.62,73.69,2.23,18.38,12.57,31.37,31.03,38.96,18.29,7.52,34.43,5.78,48.44-5.22,14-11,27.25-31.2,39.74-60.59l36.86-89.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m928.43,1133.23c-21.43,52.11-48.6,87.54-81.52,106.28-32.92,18.74-70.18,19.56-111.76,2.46-41.07-16.89-66.9-43.34-77.51-79.37-10.6-36.03-5.77-79.43,14.5-130.2l28.52-69.37c21.64-52.63,48.97-88.09,82.02-106.38,33.04-18.29,70.09-18.99,111.16-2.1,41.07,16.88,66.92,43.3,77.56,79.24,10.64,35.95,5.82,79.3-14.45,130.07l-28.52,69.37Zm-43.44-107.02c12.85-31.26,17.94-55.77,15.26-73.54-2.68-17.76-13.08-30.37-31.2-37.82-17.6-7.24-33.38-5.79-47.32,4.32-13.95,10.12-27.1,29.49-39.48,58.12l-37.71,91.72c-12.64,30.74-17.85,55.31-15.62,73.69,2.23,18.38,12.57,31.37,31.03,38.96,18.29,7.52,34.43,5.78,48.44-5.22,14-11,27.25-31.2,39.74-60.59l36.86-89.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1336.82,869.34l44.08-13.74,19.4,62.25-44.08,13.74,26.23,84.16-77.22,24.06-26.23-84.16-159.51,49.71-18.63-47.54,82.32-306.77,78.02-24.31,75.61,242.6Zm-163.25,50.88l86.03-26.81-42.8-137.33-2.33,10.4-40.9,153.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m1321.83,874.02l44.08-13.74,19.4,62.25-44.08,13.74,26.23,84.16-77.22,24.06-26.23-84.16-159.51,49.71-18.63-47.54,82.32-306.77,78.02-24.31,75.61,242.6Zm-163.25,50.88l86.03-26.81-42.8-137.33-2.33,10.4-40.9,153.75Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "C",
    className: "cls-5",
    cx: 804.08,
    cy: 495.78,
    r: 17.59
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "742.87 506.77 802.97 513.34 805.86 478.31 745.21 475.02 742.87 506.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m772.43,475.97l17.58,1.23,15.86,1.11s-.25,13.94-.56,17.7c-.41,5-2.34,17.33-2.34,17.33l-13.53-.29c-2.17-.05-21.02-1.29-23.1-.67l-2.56.77c-2.09-11.27-.14-24.48,8.65-37.17Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "754.49 478.41 745.45 471.38 739.71 466.92 735.03 463.28 706.95 441.46 689.99 458.74 733.53 502.32 754.49 478.41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "C-2",
    className: "cls-7",
    cx: 744.61,
    cy: 490.91,
    r: 15.93
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "C-3",
    className: "cls-7",
    cx: 697.85,
    cy: 449.46,
    r: 12.11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m694.14,435.48s.08.09.11.13c.03.04-.01,0-.12-.12-3.8,3.25-10.94,10.88-10.94,10.88,0,0,.72,3.51,4.11,8.99,3.24,5.24,7.24,5.75,7.24,5.75l12.91-19.06s-3.88-4.54-8.21-8.49c-1.44-.41-3.81.82-5.09,1.91Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "C-4",
    className: "cls-7",
    cx: 686.46,
    cy: 422.18,
    r: 1.92
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m688.01,421.05s-3.49-4.32-4.7-3.84c-1.98.8,1.4,5.76,1.4,5.76l3.29-1.93Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "C-5",
    className: "cls-7",
    cx: 678.45,
    cy: 428.35,
    r: 1.92
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "C-6",
    className: "cls-8",
    d: "m677.34,426.78c.87-.61,2.06-.4,2.67.46.61.87.4,2.06-.46,2.67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m680.04,427.28s-.63-.84-1.44-1.75c-.46-.52-.97-1.06-1.47-1.48-.64-.56-1.25-.92-1.64-.78-2.01.72,1.18,5.81,1.18,5.81l3.37-1.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m680.04,427.28s-.63-.84-1.44-1.75c-.46-.52-.97-1.06-1.47-1.48"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "690.54 440.21 684.43 432.24 688.28 429.01 694.92 436.45 690.54 440.21"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "C-7",
    className: "cls-7",
    cx: 692.85,
    cy: 438.47,
    r: 2.89
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "C-8",
    className: "cls-7",
    cx: 686.39,
    cy: 430.66,
    r: 2.52
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "684.4 432.2 679.05 425.11 682.3 422.33 688.28 429.01 684.4 432.2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "C-9",
    className: "cls-7",
    cx: 680.74,
    cy: 423.79,
    r: 2.14
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m682.46,422.53s-3.92-4.81-5.26-4.27c-2.21.9,1.59,6.43,1.59,6.43l3.67-2.16Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "C-10",
    className: "cls-7",
    cx: 683.16,
    cy: 434.81,
    r: 2.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "C-11",
    className: "cls-8",
    d: "m681.75,433.23c.87-.78,2.21-.7,2.99.17s.7,2.21-.17,2.99"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "681.41 436 676.89 429.46 679.91 427.1 683.31 431.53 684.84 433.52 681.41 436"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "679.91 427.1 683.31 431.53 684.84 433.52"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "C-12",
    className: "cls-7",
    cx: 688.74,
    cy: 441.93,
    r: 2.59
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "686.61 443.4 681.44 436.04 684.81 433.49 686.97 435.96 690.68 440.2 686.61 443.4"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "684.81 433.49 686.97 435.96 690.68 440.2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "C-13",
    className: "cls-7",
    cx: 676.52,
    cy: 435.33,
    r: 1.63
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m677.8,434.33s-.55-.63-1.25-1.33c-.4-.4-.85-.81-1.28-1.15-.62-.48-1.21-.8-1.55-.65-1.66.73,1.35,4.85,1.35,4.85l2.74-1.72Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "C-14",
    className: "cls-7",
    cx: 680.07,
    cy: 439.45,
    r: 1.8
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "678.67 440.57 675.27 436.37 677.8 434.33 681.32 438.16 678.67 440.57"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "C-15",
    className: "cls-7",
    cx: 685.08,
    cy: 445.27,
    r: 2.2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "683.33 446.6 678.67 440.56 681.43 438.27 683.49 440.43 686.65 443.74 683.33 446.6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "C-16",
    className: "cls-7",
    cx: 691.57,
    cy: 428.33,
    r: 2.31
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "689.64 429.62 687.76 427.11 684.94 423.35 687.87 420.87 693.23 426.73 689.64 429.62"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "C-17",
    className: "cls-7",
    cx: 697.29,
    cy: 435.33,
    r: 2.62
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "695.19 436.9 691.65 432.26 689.74 429.75 693.23 426.73 699.23 433.56 695.19 436.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 692.77,
    y1: 438.89,
    x2: 685.36,
    y2: 444.82
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "C-18",
    className: "cls-7",
    cx: 693.74,
    cy: 433.1,
    r: 2.08
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "C-19",
    className: "cls-8",
    cx: 693.74,
    cy: 433.1,
    r: 2.08
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m694.48,431.15s-3.22-1.34-4.29-1.8c-.49-.21-1.77-.76-2.07-.46-.26.25-.23.73-.16,1.25.14,1.02,1,2.03,1.95,2.85,1.29,1.11,2.73,1.88,2.73,1.88l1.84-3.71Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m694.48,431.15s-3.22-1.34-4.29-1.8c-.49-.21-1.77-.76-2.07-.46-.26.25-.23.73-.16,1.25.14,1.02,1,2.03,1.95,2.85,1.29,1.11,2.73,1.88,2.73,1.88"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "C-20",
    className: "cls-7",
    cx: 699.71,
    cy: 439.39,
    r: 3.06
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "697.32 441.28 694.86 438.02 692.18 434.48 695.01 431.45 698.64 434.5 701.75 437.11 697.32 441.28"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "695.01 431.45 698.64 434.5 701.75 437.11"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "697.32 441.28 694.86 438.02 692.18 434.48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m641.42,723.25c23.27,13.89,25.51,7.8,25.51,7.8,0,0,5.23-9.8-21.48-23.8-26.71-14-30.12-7.29-30.12-7.29,0,0-6.14,4.04,26.1,23.29Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "C-21",
    className: "cls-5",
    cx: 805.37,
    cy: 623.34,
    r: 21.49
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m703.48,638.4c29.62,2.2,98.37,6.86,101.83,6.43l1.22-42.96s-24.56-.46-75.76-4.42c-5.62-.43-20.46-1.54-26.29-2.01l-.99,42.95Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m618.13,709.19c-2.85,4.71-8.95,6.23-13.69,3.36-4.71-2.85-6.21-8.98-3.36-13.69,2.85-4.71,8.98-6.21,13.69-3.36,4.71,2.85,6.21,8.98,3.36,13.69Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m619.44,702.41c-.46-2.77-2.07-5.34-4.67-6.91-4.71-2.85-10.84-1.35-13.69,3.36-.06.1-.26.22-.17.3,8.48,7.96,17.21,3.87,18.53,3.25Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "C-22",
    className: "cls-9",
    d: "m614.88,707.22c-1.76,2.91-5.54,3.85-8.47,2.08-2.91-1.76-3.84-5.56-2.08-8.47s5.56-3.84,8.47-2.08c2.91,1.76,3.84,5.55,2.08,8.47Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m604.71,712.53s-.05.09-.08.12l-26.66-16.15s.49-1.61,2.05-3.09c1.38-1.3,3.6-2.5,7.07-2.4,6.17.17,11.62,2.08,23.62,3.1-.65,2.36-2.99,10.24-4.63,14.97-.58,1.68-1.07,2.95-1.37,3.45Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m604.71,712.53s-.05.09-.08.12l-26.66-16.15s.49-1.61,2.05-3.09l26.06,15.67c-.58,1.68-1.07,2.95-1.37,3.45Z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "C-23",
    className: "cls-9",
    cx: 653.08,
    cy: 704.28,
    r: 23.97
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m673.32,717.13l-17.76,27.53-37.32-23.45-6.48-4.08-7.28-4.57c.97-1.25,5.32-17.06,4.82-18.46,4.92-.26,7.65-.56,10.84-1.17,4.47-.85,8.7-2.71,12.31-4.46,4.89-2.38,7.39-4.16,7.39-4.16l33.49,32.82Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 626.93,
    y1: 699.32,
    x2: 622.51,
    y2: 692.47
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m605.84,708.92c-.59,1.89-1.1,3.3-1.37,3.64l7.28,4.57,6.48,4.08,37.32,23.45,2.29-3.55-52.01-32.19Z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "C-24",
    className: "cls-5",
    cx: 703.96,
    cy: 616.92,
    r: 21.49
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m666.93,731.06c21.85-40.92,55.54-103.21,55.54-103.21l-36.44-22.79s-65.69,83.79-69.04,88.58c0,0,3.63,9.35,28.93,18.58,18.4,6.71,21,18.84,21,18.84Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m844.49,836.71c26.65-4.96,24.3-11.01,24.3-11.01,0,0-2.56-10.81-31.86-3.65-29.3,7.16-27.42,14.45-27.42,14.45,0,0-1.94,7.09,34.98.21Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m817.77,841.74c.86,5.44-2.82,10.54-8.29,11.4s-10.54-2.85-11.4-8.29c-.86-5.44,2.85-10.54,8.29-11.4,5.44-.86,10.54,2.85,11.4,8.29Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m814.39,835.72c-2.14-1.82-5.03-2.74-8.03-2.26-5.44.86-9.15,5.97-8.29,11.4.02.11-.05.33.06.34,11.61.61,15.65-8.15,16.25-9.48Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "C-25",
    className: "cls-9",
    d: "m814.01,842.33c.53,3.36-1.74,6.52-5.12,7.05-3.36.53-6.52-1.76-7.05-5.12-.53-3.36,1.76-6.52,5.12-7.05,3.36-.53,6.52,1.76,7.05,5.12Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m809.68,852.96c0,.05.02.1.02.14l-30.79,4.88s-.67-1.54-.42-3.68c.22-1.89,1.14-4.23,3.85-6.4,4.83-3.85,10.22-5.91,20.04-12.88,1.02,2.22,4.33,9.75,6.12,14.42.64,1.65,1.09,2.95,1.18,3.52Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m809.68,852.96c0,.05.02.1.02.14l-30.79,4.88s-.67-1.54-.42-3.68l30.01-4.86c.64,1.65,1.09,2.95,1.18,3.52Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "C-26",
    className: "cls-9",
    cx: 840.7,
    cy: 814.76,
    r: 23.97
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m864.37,811.01l4.87,32.4-43.51,7.09-7.56,1.23-8.49,1.38c-.1-1.57-7.29-16.31-8.59-17.04,3.52-3.45,5.37-5.48,7.36-8.05,2.79-3.59,4.74-7.78,6.29-11.48,2.09-5.02,2.8-8.01,2.8-8.01l46.82,2.48Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 817.8,
    y1: 828.33,
    x2: 809.95,
    y2: 826.11
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m808.32,849.47c.81,1.81,1.35,3.2,1.38,3.63l8.49-1.38,7.56-1.23,43.51-7.09-.63-4.18-60.3,10.24Z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "C-27",
    className: "cls-5",
    cx: 821.1,
    cy: 715.57,
    r: 21.49
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m868.79,825.69c-10.66-45.14-26.58-114.16-26.58-114.16l-42.4,7s6.12,106.29,6.78,112.11c0,0,8.91,4.62,33.99-5.19,18.24-7.13,28.21.24,28.21.24Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "C-28",
    className: "cls-5",
    cx: 806.08,
    cy: 615.08,
    r: 21.49
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m842.21,711.53c-1.3-9.43-3.2-22.84-5.22-36.82-4.28-29.65-9.1-61.85-9.88-64.09l-42.25,7.84s4.71,24.11,11.6,75c.76,5.58,2.79,20.33,3.56,26.13l42.2-8.05Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m789.1,643.24c-1.13-6.42-2.2-14.89-2.59-15.32"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "C-29",
    className: "cls-5",
    cx: 799.91,
    cy: 568.45,
    r: 15.16
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m827.23,619.84s4.31-15.33-4.29-36.5c-4.98-12.26-8.04-16.98-8.04-16.98l-30.14,2.29s-.72,6.8-.59,21.45c.14,14.95.42,24.94.42,24.94l42.65,4.8Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "C-30",
    className: "cls-5",
    cx: 801.25,
    cy: 461.22,
    r: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m818.88,447.8c-2.33-8.91-15.9-11.29-25.33-7.17-3.32,1.45-6.02,4.27-8.06,7.58-.22.36-1.14,1.46-1.45,1.76-1.51,1.47-3.78,2.39-3.71,3.32.04.56,1.03,1.16,1.63,1.46.25.13.37.41.28.68-.03.09-.06.18-.08.25-1.23,4.07-1.57,7.98-.96,10.48,1.53,6.24,11.96,5.14,18.23,2.85,6.27-2.29,21.78-12.29,19.44-21.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 787.61,
    cy: 451.91,
    rx: 1.09,
    ry: 0.85,
    transform: "translate(107.18 1053.21) rotate(-71.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m790.45,438.78c.13-.17.16-.4.06-.6-.25-.49-.71-1.5-.98-2.63-.37-1.51-.1-2.71.19-3.44.15-.39.65-.49.94-.19.47.48,1.26,1.18,2.45,1.88,1.87,1.1,3.92,1.96,5.5,2.2,4.88.74,9.49-3.82,17.34,2.16,6.64,5.06,4.55,10.05,3.76,11.46-.13.23-.09.52.11.69,1.24,1.13,5.07,5.38.67,11.46-2.21,3.04-5.4,3.2-8.41,3.09-4.16-.16-6.53-3.13-6.53-3.13l-.03-.02c-.49-.66-3.57-3.73-3.73-5.2-.31-2.82,1.1-4.99,1.89-5.96.23-.28.14-.7-.18-.86-.73-.37-1.88-1.07-2.5-1.98-1.58-2.34-2.61-5.58-4.41-6.41-3.52-1.61-5.86.94-7.18,2.32-.39.41-1.07.06-.97-.5.34-2,1.52-3.69,2.03-4.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 805.68,
    cy: 461.2,
    rx: 8.11,
    ry: 4.62,
    transform: "translate(-114.76 582.13) rotate(-37.27)"
  }))), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "C-31",
    className: "cls-9",
    cx: 799.92,
    cy: 568.45,
    r: 15.16
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m840.02,600.06h0c-4.65-20.32-8.78-58.61-8.85-79.45-.07-19.47-7.34-41.11-25.49-42.25-9.57-.6-23.38,4.18-25.68,27.34-.57,5.72-1.04,12.44-1.42,19.63-.63,11.67-1.04,24.56-1.31,36.29-.49,21.07-.51,38.45-.51,38.45,0,0,5.1,5.34,28.04,1.87,17.35-2.63,35.23-1.87,35.23-1.87Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "783.71 452.68 787.98 439.31 784.31 438.19 781.06 448.24 763.19 444.71 762.45 448.48 783.71 452.68"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m789.45,453.81l-6.04-1.19.74-3.76,6.21,1.23c-.38,1.48-.91,3.73-.91,3.73Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 632.28,
    cy: 419.64,
    rx: 22.67,
    ry: 13.07,
    transform: "translate(117.74 977.42) rotate(-80.88)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "629.52 442.12 770.85 451.08 772.28 444.3 637.47 397.7 629.52 442.12"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 632.28,
    cy: 419.64,
    rx: 22.67,
    ry: 13.07,
    transform: "translate(117.74 977.42) rotate(-80.88)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m628.69,442.02c.79.13,1.58.13,2.36.01-4.78-3.69-7.22-12.78-5.61-22.81,1.76-10.99,7.81-19.41,14.13-20.32-1.12-.86-2.36-1.43-3.71-1.65-7.13-1.14-14.51,7.95-16.5,20.31-1.98,12.36,2.19,23.31,9.31,24.45Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 771.55,
    cy: 451.09,
    r: 4.61
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "745.36 449.42 747.9 436.3 729.22 429.42 725.93 448.23 745.36 449.42"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "C-32",
    className: "cls-7",
    cx: 724.2,
    cy: 462.98,
    r: 12.11
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m724.69,448.03s.06.1.09.14c.03.04-.01,0-.1-.14-4.3,2.56-12.62,8.88-12.62,8.88,0,0-1.1,4.66.98,10.76,1.48,4.34,6.29,6.39,6.29,6.39l16.4-14.8s-1.15-4.61-5.8-12.29c-1.35-.65-3.8.19-5.25,1.05Z"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "C-33",
    className: "cls-7",
    cx: 719.37,
    cy: 433.63,
    r: 1.92
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m721.09,432.78s-2.71-4.85-3.98-4.58c-2.08.45.41,5.92.41,5.92l3.57-1.34Z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "C-34",
    className: "cls-7",
    cx: 710.44,
    cy: 438.36,
    r: 1.92
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m712.09,437.38s-.37-.74-1.02-1.77c-.36-.59-.78-1.21-1.2-1.71-.54-.66-1.08-1.12-1.49-1.04-2.1.37.18,5.93.18,5.93l3.52-1.4Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "720.35 452.09 715.67 443.2 720.02 440.67 725.31 449.13 720.35 452.09"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "C-35",
    className: "cls-7",
    cx: 722.92,
    cy: 450.77,
    r: 2.89
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "C-36",
    className: "cls-7",
    cx: 717.87,
    cy: 441.98,
    r: 2.52
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "715.65 443.16 711.58 435.27 715.25 433.08 720.02 440.67 715.65 443.16"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "C-37",
    className: "cls-7",
    cx: 713.46,
    cy: 434.26,
    r: 2.14
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m715.38,433.3s-3.05-5.41-4.46-5.09c-2.33.51.48,6.61.48,6.61l3.98-1.51Z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "C-38",
    className: "cls-7",
    cx: 713.99,
    cy: 445.52,
    r: 2.12
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "712.07 446.41 708.71 439.19 712.09 437.38 714.69 442.31 715.84 444.5 712.07 446.41"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "C-39",
    className: "cls-7",
    cx: 718.29,
    cy: 453.48,
    r: 2.59
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "715.94 454.57 712.09 446.45 715.84 444.5 717.55 447.3 720.49 452.11 715.94 454.57"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "C-40",
    className: "cls-7",
    cx: 707.35,
    cy: 444.92,
    r: 1.63
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m708.69,443.99s-.33-.55-.91-1.36c-.33-.46-.7-.94-1.07-1.35-.53-.58-1.06-.99-1.42-.9-1.76.44.51,5.01.51,5.01l2.89-1.4Z"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "C-41",
    className: "cls-7",
    cx: 710.16,
    cy: 449.57,
    r: 1.8
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "708.59 450.44 705.95 445.73 708.69 443.99 710.17 446.17 711.7 448.64 708.59 450.44"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "C-42",
    className: "cls-7",
    cx: 714.12,
    cy: 456.16,
    r: 2.2
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "712.16 457.17 708.59 450.43 711.7 448.64 713.37 451.12 715.92 454.91 712.16 457.17"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "C-43",
    className: "cls-7",
    cx: 723.34,
    cy: 440.52,
    r: 2.31
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "721.31 441.61 719.83 438.71 717.68 434.53 720.98 432.58 725.33 439.34 721.31 441.61"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "C-44",
    className: "cls-7",
    cx: 727.8,
    cy: 448.44,
    r: 2.59
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "725.49 449.62 722.79 444.45 721.33 441.65 725.33 439.34 729.94 446.99 725.49 449.62"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "C-45",
    className: "cls-5",
    cx: 804.15,
    cy: 496.23,
    r: 17.59
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "756.99 532.45 811.08 512.4 797.85 479.84 742.24 504.28 756.99 532.45"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m766.76,516.31c-6.64-9.57-7.88-22.91-7.95-25.18l7.03-.79c2.49-.11,12.85-3.48,15.18-4.34l16.83-6.16,13.23,32.57-9.16,3.92-13.19,5.64-12.94,5.53c-.07-.1-3.76-3.57-9.04-11.18Z"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "763.08 511.5 757.56 500.87 754.46 494.89 735.33 458.27 712.71 466.68 734.05 524.47 763.08 511.5"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "C-46",
    className: "cls-7",
    cx: 748.89,
    cy: 518.73,
    r: 15.93
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 755.67,
    y1: 497.22,
    x2: 739.95,
    y2: 467.11
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 712.71,
    y1: 466.68,
    x2: 721.5,
    y2: 490.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/Error404.a5bb26e8080777f1cb0879ec1e65799a.svg";
export { ForwardRef as ReactComponent };